import { useEffect, useRef, useState } from 'react';
import './otpinput.css';

const OTPInput = ({ length = 6, setUserData, keyName, handleKeyDown, resetKey }) => {
    const inputRef = useRef(Array(length).fill(null));
    const [OTP, setOTP] = useState(Array(length).fill(''));

    useEffect(() => {
        setOTP(Array(length).fill(''));

        setUserData((prevState) => ({
            ...prevState,
            [keyName]: ''
        }));

        inputRef.current[0]?.focus();
    }, [resetKey]);

    const handleTextChange = (input, index) => {
        // Allow only numeric values
        if (!/^\d*$/.test(input)) return;
        const newPin = [...OTP];
        newPin[index] = input;
        //update the OTP in the emailOTP or phoneOTP in parent page
        const newStringOTP = newPin.join('');
        setUserData((prevState) => {
            return { ...prevState, [keyName]: newStringOTP };
        });
        setOTP(newPin);

        if (input.length === 1 && index < length - 1) {
            inputRef.current[index + 1]?.focus();
        }
    };

    function handleDelete(index) {
        const newPin = [...OTP];
        newPin[index] = '';
        //update the OTP in the emailOTP or phoneOTP in parent page
        const newStringOTP = newPin.join('');
        console.log(newStringOTP);
        setUserData((prevState) => {
            return { ...prevState, [keyName]: newStringOTP };
        });
        setOTP(newPin);
        if (index > 0) {
            inputRef.current[index - 1]?.focus();
        }
    }

    return (
        <div className='otpinput-wrapper'>
            {Array.from({ length }, (_, index) => (
                <input
                    key={index}
                    type='text'
                    maxLength={1}
                    pattern='[0-9]*'
                    inputMode='numeric'
                    autoComplete={index === 0 ? 'one-time-code' : 'off'}
                    value={OTP[index]}
                    onChange={(e) => handleTextChange(e.target.value, index)}
                    onKeyDown={(event) => {
                        if (event.key === 'Backspace' || event.key === 'Delete') {
                            handleDelete(index);
                        }
                        if (index === length - 1) {
                            handleKeyDown(event);
                        }
                    }}
                    ref={(ref) => (inputRef.current[index] = ref)}
                    className='otpinput no-spinner'
                />
            ))}
        </div>
    );
};

export default OTPInput;
